// extracted by mini-css-extract-plugin
export default {"text":"NavigationWarningModal_text__GKJ-X","fetchButton":"NavigationWarningModal_fetchButton__b6n54"};